import Select, { components, CSSObjectWithLabel, InputProps } from "react-select";
import { TargetTypeOption } from "@ts/multi-select-dropdown";

const Input = (props: InputProps<TargetTypeOption, true>) => {
    return <components.Input {...props} />;
};

interface IProps {
    options: any;
    placeholder: string;
    setSelectedOptions: any;
    targetSelected?: {
        value: string;
    }[];
    type?: string;
    setCampaignField?: (field: string, value: string) => void;
}

const SingleSelectDropDown: React.FC<IProps> = (props) => {
    const targetClassOptions: TargetTypeOption[] = [];

    const handleChange = (options: any) => {
        props.setSelectedOptions(options);
    };

    return (
        <>
            <Select
                closeMenuOnSelect={false}
                placeholder={props.placeholder}
                styles={{
                    placeholder: (base: CSSObjectWithLabel) => ({
                        ...base,
                        fontSize: "1rem",
                    } as CSSObjectWithLabel),
                }}
                components={{ Input }}
                options={
                    props.targetSelected ? targetClassOptions : props.options
                }
                isClearable
                onChange={handleChange}
            />
        </>
    );
};

export default SingleSelectDropDown;
